import * as React from 'react';
import cx from 'classnames';
import { ScrollElement } from 'react-scroll';
import styles from './ScreenSection.module.scss';

const ScrollSection = ScrollElement(({ parentBindings, ...props }) => {
  return <section {...props} name={props.id} />;
});

const ScreenSection = ({ children, style, theme, background, noLimit, ...rest }) => (
  <ScrollSection className={cx(styles.base, styles[`base_theme_${theme}`])} style={style} {...rest}>
    {background && (
      <div className={styles.background} style={{ backgroundImage: `url(${background})` }} />
    )}
    <div className={cx(styles.content, { [styles.content_nolimit]: noLimit })}>{children}</div>
  </ScrollSection>
);

export default ScreenSection;
